import React, { useState } from "react";

import { PrimaryButton, SecondaryButton, SingleSelect, Text } from "widgets";
import { JODO_FLEX } from "constants/config";
import { useSwitchPaymentProvider } from "store/backend/assets";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import Loader from "Shared/Loader/Loader";

import styles from "./SwitchProvider.module.scss";

const handleNext = (provider, setShowConfirmation) => {
  if (provider) {
    setShowConfirmation(true);
  }
};

const handleGoBack = (showConfirmation, setShowConfirmation) => {
  if (showConfirmation) {
    setShowConfirmation(false);
  }
  return;
};

const handleOnClickConfirm = (
  switchPaymentProvider,
  openSnackbar,
  orderId,
  provider,
) => {
  const payload = {
    order_id: orderId,
    provider_id: provider,
  };
  switchPaymentProvider(payload, {
    onSuccess: () => {
      window.location.reload();
      openSnackbar("Successfully switched provider", "success");
    },
    onError: (error) => {
      openSnackbar(`Error switching provider: ${error}`, "error");
    },
  });
};
const SwitchProvider = (props) => {
  const { onClose, orderId } = props;
  const [provider, setProvider] = useState("");
  const { openSnackbar } = useSnackbarContext();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const {
    mutate: switchPaymentProvider,
    isPending: isSwitchingProviderPending,
  } = useSwitchPaymentProvider();

  return (
    <div className={styles.switchProviderContainer}>
      {!showConfirmation ? (
        <div className={styles.selectProvider}>
          <Text>Please select the part payment provider</Text>
          <SingleSelect
            menuItems={[JODO_FLEX]}
            value={provider}
            handleChange={(event) => setProvider(event.target.value)}
            tag="Select Provider"
          />
          <div className={styles.flexContainer}>
            <SecondaryButton onClick={onClose}>Go Back</SecondaryButton>
            <PrimaryButton
              onClick={() => handleNext(provider, setShowConfirmation)}
              disabled={!provider}
            >
              Next
            </PrimaryButton>
          </div>
        </div>
      ) : (
        <div className={styles.providerConfirmation}>
          <div className={styles.warningText}>WARNING!</div>
          <div className={styles.message}>
            Once confirming you will not be able to switch back to the previous
            provider.
          </div>

          <div className={styles.flexContainer}>
            <SecondaryButton
              onClick={() =>
                handleGoBack(showConfirmation, setShowConfirmation)
              }
            >
              Go Back
            </SecondaryButton>
            <PrimaryButton
              onClick={() =>
                handleOnClickConfirm(
                  switchPaymentProvider,
                  openSnackbar,
                  orderId,
                  provider,
                )
              }
            >
              {isSwitchingProviderPending ? <Loader /> : "Confirm and Proceed"}
            </PrimaryButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default SwitchProvider;
